<div class="container-fluid position-relative p-0 m-0 min-vh-100">

    <div class="row gx-0 min-vh-100">

        <!-- First Section -->
        <div class="col-12 col-md-6 col-lg-8 d-flex flex-column bg-white position-relative">
            <div class="d-flex justify-content-start position-relative z-index-1 m-2">
                <app-language-toggle-button class="ms-auto"></app-language-toggle-button>
            </div>

            <div class="p-5 pt-lg-10 ps-lg-10 pb-lg-20 pe-lg-10 mt-lg-20 ms-lg-20 me-lg-20 pt-md-10 ps-md-2 pb-md-10 pe-md-2 mt-md-10 ms-md-2 me-md-2"
                style="height: 100%;">
                <!-- content here -->

                <ng-content></ng-content>

            </div>

            <!-- <div class="w-100 position-absolute top-0 left-0 d-none d-md-flex gap-2" style="z-index: 9999;">
                <img src="./assets/media/auth/top-left-arc.svg" alt="top left arc" class="" style="
                  width: 15%;
                  height: 15%;
                " />

                <img src="./assets/media/auth/ball.svg" alt="ball" class="d-none d-md-block"
                    style="width: 35px; height: 35px; margin: 10px" />
            </div> -->

            <!-- <img src="./assets/media/auth/bottom-left-arc.svg" alt="bottom left arc"
                class="position-absolute bottom-0 left-0 d-none d-md-block" style="
              width: 10%; 
              height: 10%; 
              z-index: 9999;
            " /> -->
        </div>

        <!-- Second Section -->
        <div class="col-12 col-md-6 col-lg-4 position-relative" [style]="'background-color: ' + bgColor + ';'">

            <div class="d-flex flex-column align-items-center justify-content-center min-vh-100 p-5">
                <h1 style="
                color: #FFFFFF;
                font-family: 'Cairo', sans-serif;
                font-weight: 600;
                font-size: 34px;
                          ">
                    {{title}}
                </h1>
                <h2 style="
                color: #FFFFFF;
                font-family: 'Cairo', sans-serif;
                font-weight: 400;
                font-size: 24px;
                          ">
                    {{subTitle}}
                </h2>
                <a routerLink="/" role="button">
                    <img alt="logo" [src]="imgUrl" class="img-fluid d-block mx-auto" style="max-width: 90%;"
                        loading="lazy" />
                </a>
            </div>

            <img src="./assets/media/auth/top-right-arc.svg" alt="top right arc"
                class="position-absolute top-0 d-none d-md-block" style="
                width: 25%; 
                height: 25%; 
                z-index: 9999;
                right: 0;
              " />
        </div>

        <img src="./assets/media/auth/bottom-middle-arc.svg" alt="bottom middle arc"
            class="position-absolute bottom-0 d-none d-md-block arc-bottom-middle" />
    </div>
</div>